<template>
  <el-menu class="navbar" mode="horizontal">
    <div style="flex:1">
      <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
      <breadcrumb></breadcrumb>
    </div>
    <div class="rightWrap" >
      <div class="audioClass">
        <!-- <audio ref="audioRef" controls >
          <source :src="msgAudio" type="audio/mpeg">
          您的浏览器不支持 audio 元素。
        </audio> -->
      </div>
      <div class="avatar-container">
        <div class="avatar-wrapper">
          <!-- <el-button type="primary"  style="display:block;margin-right: 10px;font-size: 14px; padding: 0px 20px;" 
              class="btn-add curPon" @click="queryCompanyBalance">余额查询</el-button> -->
          <!-- <span class="curPon" @click="authCode" style="display:block;margin-right: 10px;font-size: 14px;">授权二维码</span> -->
          <!-- <img class="user-avatar" :src="avatar"> -->
          <!-- <img class="user-avatar" :src="logoPng">
          <span>CRM</span> -->
          <span style="margin-left: 20px;">{{nickName || '--'}}
            <!-- ({{ username || '--'}}/{{usercode || '--'}}/{{companyName || '--'}}) -->
              <!-- <span v-if="duty">({{ duty }})</span> -->
          </span>
          <span class="curPon" @click="updatePasClick" style="display:block;margin-left: 10px;font-size: 14px;">修改密码</span>
          <span class="curPon" @click="logout" style="display:block;margin-left: 10px;font-size: 14px;">退出登录</span>
        </div>
      </div>
    </div>
    <!-- <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    
  <upPas v-if="dialogData.dialogVisible" :params="dialogData" @listenDialog="listenDialog"></upPas>
  
  <dialogCon v-if="dialogData1.dialogVisible" :params="dialogData1" @listenDialog="listenDialog"></dialogCon>
  </el-menu>
</template>

<script>
import { mapGetters ,mapState} from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import upPas from '@/views/login/upPas.vue'
import baseApi from '@/api/baseApi.js';
  import dialogCon from '@/components/dialog'
  import qrCode from './qrCode.vue'
  import companyBalace from './companyBalace.vue'
  import msgAudio from '@/assets/audio/tipsAudio.mp3';
import { getToken, setToken, removeToken } from '@/utils/auth'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    upPas,dialogCon
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ]),
    ...mapState({
      clueObj:state => state.fold.clueObj
    })
  },
  data(){
    return{
      logoPng:require("@/assets/images/logo.png"),
      username:'',
      nickName:'',
      companyName:'',
      duty:'',
      usercode:'',
        // 修改密码   动态组件
        updatePasData:{
          dialogVisible:false,
          title:'修改密码',
          width:'500px',
          type:1,
          isComponebt:true,//显示组件
          component:upPas,//组件传递
          data:{id:''},
        },
        dialogData:{},//弹窗数据
        dialogData1:{},//二维码
        
        // 二维码
        financingData:{
          dialogVisible:false,
          title:'还款二维码',
          width:'20%',
          isComponebt:true,//显示组件
          component:null,//组件传递
          data:{id:''},
        },
        msgAudio:msgAudio,
        audioPlayer:null,
    }
  },
  watch: {
    clueObj:{
      handler:function(newValue, oldValue) {
        if(newValue.clueLen > 0 && this.audioPlayer){
        // if(this.audioPlayer){
          this.audioPlayer.play();
          console.log("有待分配数据   播放提示")
        }
        console.log("111111",newValue, oldValue,this.audioPlayer)
      },
      deep: true,
      immediate:true
    },
    },
  created () {
    this.username = sessionStorage.getItem("username")
    this.nickName = sessionStorage.getItem("nickName")
    this.usercode = sessionStorage.getItem("usercode")
    this.companyName = sessionStorage.getItem("companyName")
    this.duty = sessionStorage.getItem("duty") || ""
  },
  mounted () {
    this.$nextTick(()=>{
      this.audioPlayer = this.$refs.audioRef;
          // this.audioPlayer.play();
    })
  },
  methods: {//监听dialog事件
      listenDialog(data){
        console.log("监听数据",data)
        let that = this;
        let type = data.type || '0';
        switch(type){
          case 1:
            //修改密码
            let username = sessionStorage.getItem("username") || "";
            let bodyData = {
              username:username,
              oldPassword:data.data.oldPassword,
              newPassword:data.data.newPassword,
              newPasswordSure:data.data.newPasswordSure,
              phone:data.data.phone
            }
            if(bodyData.newPassword != bodyData.newPasswordSure){
              return this.$utils.msg('新密码与确认密码不一致，请重新输入','error')
            }
            baseApi.updatePassword(bodyData)
            .then( res => {
              this.$message({
                  message: '修改成功',
                  type: 'success',
                  duration:1500
                })
                that.dialogData.dialogVisible = false;
                //清除token
                removeToken();
            });
          break;
          default:
            console.log("监听事件",data)
        }
      },
      authCode(){
        let that = this;
        that.dialogData1 = that.financingData;
        that.dialogData1.title=`微信授权二维码`
        that.dialogData1.width = '25%'
        that.dialogData1.component = qrCode;
        let userId = sessionStorage.getItem("id") || '0';
        that.dialogData1.data.id =userId;
        that.dialogData1.data.paramsData={
          // url:`https://crmuser.efenda.cn/pages/order/pay?agentName=${qrData.agentName}&userId=${qrData.userId}&amt=${qrData.amt}&remark=${qrData.remark}`,
          // url:`https://b.efenda.cn/pages/public/crmWXAuth?userId=${userId}`,
          url:`https://crmuser.efenda.cn/pages/public/crmWXAuth?userId=${userId}`,
          id:userId
        }
        that.dialogData1.dialogVisible = true;
      },
      //修改密码
      updatePasClick(){
        console.log("修改数据")
        let that = this;
        that.dialogData = that.updatePasData;
        that.dialogData.dialogVisible = true;
      },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        });
    },
    //余额查询
    queryCompanyBalance(){
        let that = this;
        that.dialogData1 = that.financingData;
        that.dialogData1.title=`公司余额查询`
        that.dialogData1.width = '80%'
        that.dialogData1.component = companyBalace;
        // let userId = sessionStorage.getItem("id") || '0';
        // that.dialogData1.data.id =userId;
        // that.dialogData1.data.paramsData={
        //   url:`https://crmuser.efenda.cn/pages/public/crmWXAuth?userId=${userId}`,
        //   id:userId
        // }
        that.dialogData1.dialogVisible = true;
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.audioClass{
  visibility: hidden;
  width:10px;
}
.curPon{
  cursor: pointer;
}
.btn-add{
  height: 30px;
  line-height: 30px;
}
/deep/ .filter-container {
    margin-bottom: 20px;
  }

  /deep/ .el-card__body {
    padding-bottom: 0;
  }

  /deep/ .el-dialog__body {
    max-height: 75vh;
    overflow-y: scroll;
    padding: 16px 20px;
  }
.rightWrap{
  flex: 2;
  display: flex;
  justify-content: space-between;
  padding-right: 40px;
  box-sizing: border-box;
}
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  display: flex;
  justify-content: space-between;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    // display: inline-block;
    // position: absolute;
    // right: 35px;
    .avatar-wrapper {
    display: flex;
      // margin-top: 5px;
      position: relative;
      align-items: center;
      .user-avatar {
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue